// Libraries
var React = require('react');

// Style
require('../AlphaList/AlphaList.scss');

class SupportersClubListModule extends React.Component {
  constructor(props) {

    super(props);

    this.state = {
      results: this.parseResults(this.props.results)
    }

  }

  componentWillReceiveProps(props) {

    this.setState({
      results: this.parseResults(props.results)
    });

  }

  parseResults(results) {

    const sortedResults = results.sort((a, b) => a.title.localeCompare(b.title));

    let organisedResults = {};

    {sortedResults.map((result) => {
      
      let firstLetter = result.title.charAt(0).toLowerCase();
      if (organisedResults[firstLetter] === undefined) { organisedResults[firstLetter] = []; }
      organisedResults[firstLetter].push(result);

    })}

    return organisedResults;

  }

  handleFauxLinkClick(website, event) {

    if (!website || website === '') return;

    const tagName = event.target.tagName.toLowerCase();

    if (
      tagName !== 'a' &&
      tagName !== 'button' &&
      website !== ''
    ) {

      window.open(website, '_self');

    }

  }

  formatUrlForDisplay(url) {

    url = url.replace('www.', '');
    url = url.replace('http://', '');
    url = url.replace('https://', '');
    return url;

  }

  render() {
    return (
      <div className={`c-section c-section--supporters-clubs${this.props.isPremium ? " c-section--premium" : ""}`}>
        <div className="c-section__inner">
          <div className="c-section__inner__inner">

            <div className="c-alpha-list">
              {Object.entries(this.state.results).map(([key, value]) => (
                <div key={key + Math.random()} className="c-alpha-list__section">
                  <p className="c-alpha-list__section__title">{key}</p>
                  <ul className="c-alpha-list__section__list">
                    {value.map((club, index) => {
                      const hasWebsite = club.website && club.website !== '';
                      const hasEmail = club.email && club.email !== '';
                      const hasLogo = club.logo && club.logo.url && club.logo.url !== '';
                      return(
                        <li key={index} className="c-alpha-list__section__list__item">
                          <div className={`c-alpha-list__section__list__item__inner${club.url && club.url !== '' ? " c-alpha-list__section__list__item__inner--faux-link" : ""}`} onClick={this.handleFauxLinkClick.bind(this, club.url)}>
                            <div className="c-alpha-list__section__list__item__inner__inner">
                              <div className="c-alpha-list__section__list__item__content">
                                <h3 className={`c-alpha-list__section__list__item__content__title${club.isNew ? " c-alpha-list__section__list__item__content__title--new" : ""}`}>
                                  {(club.url && club.url !== '') &&
                                    <a href={club.url} className="c-alpha-list__section__list__item__content__title__link">
                                      {club.title}
                                    </a>
                                  }
                                  {(club.url && club.url === '') &&
                                    <span>
                                      {club.title}
                                    </span>
                                  }
                                </h3>
                                {(hasWebsite || hasEmail) &&
                                  <ul className="c-alpha-list__section__list__item__content__list">
                                    {(hasWebsite) &&
                                      <li className="c-alpha-list__section__list__item__content__list__item">
                                        <a href={club.website} className="c-alpha-list__section__list__item__content__list__item__link" target="_blank" rel="noopener external">
                                          {this.formatUrlForDisplay(club.website)}
                                        </a>
                                      </li>
                                    }
                                    {(hasEmail) &&
                                      <li className="c-alpha-list__section__list__item__content__list__item">
                                        <a href={`mailto:${club.email}`} className="c-alpha-list__section__list__item__content__list__item__link">
                                          {club.email}
                                        </a>
                                      </li>
                                    }
                                  </ul>
                                }
                              </div>
                              {(hasLogo) &&
                                <div className="c-alpha-list__section__list__item__image-wrapper">
                                  <div className="c-alpha-list__section__list__item__image-wrapper__inner">
                                    <img src={club.logo.shareUrl} alt="" loading="lazy" className="c-alpha-list__section__list__item__image-wrapper__asset" />
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ))}
            </div>
          
          </div>
        </div>
      </div>
    );
  }
};

module.exports = SupportersClubListModule;


// WEBPACK FOOTER //
// ./src/components/SupportersClub/List.js